import React from "react";
import { Helmet } from "react-helmet-async";
import { Phone, Mail, MapPin, Clock, Shield } from "lucide-react";
import { companyInfo } from "../data";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Kontakt - Henneberg Byggeri ApS</title>
        <meta
          name="description"
          content="Kontakt Henneberg Byggeri ApS på tlf. 31444011 eller mail@hennebergbyggeri.dk. Vi bor på Vr Janderupvej 11 i Janderup Vestj. Få et uforpligtende tilbud i dag."
        />
        <meta property="og:title" content="Kontakt - Henneberg Byggeri ApS" />
        <meta
          property="og:description"
          content="Kontakt Henneberg Byggeri ApS på tlf. 31444011 eller mail@hennebergbyggeri.dk. Vi bor på Vr Janderupvej 11 i Janderup Vestj."
        />
        <link rel="canonical" href="https://hennebergbyggeri.dk/kontakt" />
      </Helmet>

      {/* Kontakt Info & Formular */}
      <section className="py-16 sm:py-24 bg-white text-neutral-900">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
            {/* Kontaktoplysninger */}
            <div className="space-y-8">
              <div>
                <h1 className="mt-2 text-2xl font-extrabold tracking-tight text-neutral-900 sm:text-3xl uppercase">
                  Henneberg Byggeri ApS
                </h1>
                <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed">
                  Du er altid velkommen til at ringe eller skrive til os. Vi bestræber os på at besvare alle e-mails inden for 24 timer på hverdage.
                </p>
              </div>

              {/* Info kort */}
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                {/* Telefon */}
                <div className="rounded-none border border-neutral-200 bg-white p-5 flex items-start gap-4">
                  <div className="flex shrink-0 items-center justify-center text-neutral-900 pt-0.5">
                    <Phone className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-neutral-900">Ring til os</h3>
                    <a
                      href={`tel:${companyInfo.phone}`}
                      className="mt-1.5 block text-sm text-gray-600 hover:text-neutral-900 transition-colors whitespace-nowrap font-medium"
                    >
                      {companyInfo.phone}
                    </a>
                    <span className="text-[11px] text-gray-400 block mt-1">Mandag - Fredag</span>
                  </div>
                </div>

                {/* Email */}
                <div className="rounded-none border border-neutral-200 bg-white p-5 flex items-start gap-4">
                  <div className="flex shrink-0 items-center justify-center text-neutral-900 pt-0.5">
                    <Mail className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-neutral-900">Skriv en e-mail</h3>
                    <a
                      href={`mailto:${companyInfo.email}`}
                      className="mt-1.5 block text-sm text-gray-600 hover:text-neutral-900 transition-colors whitespace-nowrap font-medium"
                    >
                      {companyInfo.email}
                    </a>
                    <span className="text-[11px] text-gray-400 block mt-1">Svar inden for 24 timer</span>
                  </div>
                </div>

                {/* Adresse */}
                <div className="rounded-none border border-neutral-200 bg-white p-5 flex items-start gap-4">
                  <div className="flex shrink-0 items-center justify-center text-neutral-900 pt-0.5">
                    <MapPin className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-neutral-900">Besøg os</h3>
                    <p className="mt-1.5 text-sm text-gray-600 leading-relaxed font-medium">
                      {companyInfo.address}
                    </p>
                  </div>
                </div>

                {/* CVR */}
                <div className="rounded-none border border-neutral-200 bg-white p-5 flex items-start gap-4">
                  <div className="flex shrink-0 items-center justify-center text-neutral-900 pt-0.5">
                    <Shield className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-neutral-900">Virksomhed</h3>
                    <p className="mt-1.5 text-sm text-gray-600 font-medium">
                      CVR: {companyInfo.cvr}
                    </p>
                    <span className="text-[11px] text-gray-400 block mt-1">Henneberg Byggeri ApS</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Kontaktformular */}
            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps Kortvisning */}
      <section className="w-full h-[450px] bg-gray-100 border-t border-gray-200 relative">
        <iframe
          title="Henneberg Byggeri ApS lokation på kort"
          src="https://maps.google.com/maps?q=Vr%20Janderupvej%2011,%206851%20Janderup%20Vestj&t=&z=14&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0"
        ></iframe>
      </section>
    </>
  );
}
